

































import {
  Component, PropSync, Prop, Vue,
} from 'vue-property-decorator';
import ChangedDocumentStatusDialogViewModel
  from '@/vue-app/view-models/allianz-dashboard/allianz-actions/changed-document-status/changed-document-status-dialog-view-model';

@Component({
  name: 'ChangedDocumentStatusDialog',
  components: {
    ChangedDocumentStatusDocumentReceived: () => import('@/vue-app/components/allianz-dashboard/allianz-actions/changed-document-status/ChangedDocumentStatusDocumentReceived.vue'),
    ChangedDocumentStatusNeedSignature: () => import('@/vue-app/components/allianz-dashboard/allianz-actions/changed-document-status/ChangedDocumentStatusNeedSignature.vue'),
    ChangedDocumentStatusSendToAllianz: () => import('@/vue-app/components/allianz-dashboard/allianz-actions/changed-document-status/ChangedDocumentStatusSendToAllianz.vue'),
  },
})
export default class ChangedDocumentStatusDialog extends Vue {
  @Prop(String)
  status!: string;

  @Prop(String)
  document_type!: string;

  @PropSync('isOpen', { type: Boolean, required: true })
  synced_is_open!: boolean;

  changed_document_view_model = Vue.observable(
    new ChangedDocumentStatusDialogViewModel(),
  );

  closeDialog() {
    this.synced_is_open = false;
  }

  mounted() {
    this.changed_document_view_model.initialize(this.status);
  }
}
